var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.667 1.333 1.729 8.46c-.233.279-.349.418-.35.536-.002.102.044.2.123.264.092.074.274.074.637.074H7l-.667 5.334 5.938-7.126c.233-.279.349-.418.35-.536a.33.33 0 0 0-.123-.264c-.092-.074-.273-.074-.637-.074h-4.86z"
  })));
};
export default SvgLightning;